import axios from "axios"



const Instance = axios.create({
    baseURL:"https://fluxcars.herokuapp.com",
    // baseURL:"http://localhost:80",
})

export default Instance